import { render, staticRenderFns } from "./orderFormType.vue?vue&type=template&id=4d337597&"
import script from "./orderFormType.vue?vue&type=script&lang=js&"
export * from "./orderFormType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d337597')) {
      api.createRecord('4d337597', component.options)
    } else {
      api.reload('4d337597', component.options)
    }
    module.hot.accept("./orderFormType.vue?vue&type=template&id=4d337597&", function () {
      api.rerender('4d337597', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/orderFormType.vue"
export default component.exports